
import { useState, createContext, useEffect, use } from 'react';
import { toast } from 'react-toastify';

import { userLogin, permissoesUser, permissoesPerfil } from '../services/apigateway.js';

export const AuthContext = createContext({});

export default function AuthProvider({ children }){
  const [usuario, setUsuario] = useState(null);
  const [loadingAuth, setLoadingAuth] = useState(false);
  const [loading, setLoading] = useState(true);
  const [signed, setSigned] = useState(false);

  const [clientes, setClientes] = useState([]);
  const [identificador, setIdentificador] = useState(null);
  const [clientSelected, setClientSelected] = useState('');
  const [clienteId, setClienteId] = useState(null);
  const [perfilUsuario, setPerfilUsuario] = useState('VS');
  const [permissoes, setPermissoes] = useState([]);
  const [ligaMenu, setLigaMenu] = useState(true);

  const [processandoImportacao, setProcessandoImportacao] = useState(true);
  const [usuarioImportacao, setUsuarioImportacao] = useState('');

  useEffect(()=>{
   }, [])

  //Fazendo login do usuario no MySQL
  async function signIn(user, password){
    setLoadingAuth(true);

    try {
      const respApi = await userLogin(user, password);

      if (respApi.length !== 0) {
        setUsuario(respApi[0]);
        setSigned(true);

        // Busca os clientes do usuário logado
        setPermissoes([]);

        const resp = await permissoesUser(respApi[0].codigo);

        if (resp.length !== 0) {
          setClientes(resp);
          setClientSelected('');
          setIdentificador('');
        }
      }

    } catch (err) {
      console.log(`Retornou o seguinte erro: ${err}`);
      toast.error('Erro no Login do Usuário!');

    } finally {
      setLoading(false);
      setLoadingAuth(false);
    }
  }

  function storageUser(data){
    localStorage.setItem('SistemaUser', JSON.stringify(data));
  }

  function togleMenu() {
    setLigaMenu(!ligaMenu);
  }

  function togleProcessandoImportacao(user) {
    setUsuarioImportacao(user);
    setProcessandoImportacao(!processandoImportacao);
  }

  //Logout do usuario
  async function signOut(){
    localStorage.removeItem('SistemaUser');

    setUsuario(null);
    setSigned(false);
    setClientSelected(null);
    setClientes([]);
  }

  async function loadClientSelected(clienteSelecionado){
    if (clienteSelecionado) {
      setClientSelected(clienteSelecionado);
      setClienteId(clientes[clienteSelecionado].cod_cliente);
      setPerfilUsuario(clientes[clienteSelecionado].per_usucliente);
      setIdentificador(clientes[clienteSelecionado].idt_cliente);
      setPermissoes([]);

      // console.log('perfil do usuário: ', clientes[clienteSelecionado].per_usucliente);

      try {
        const resp = await permissoesPerfil(clientes[clienteSelecionado].per_usucliente);

        if (resp.length !== 0) {
          setPermissoes(resp);
        }

      } catch(err) {
        console.log(`Retornou o seguinte erro: ${err}`);
        toast.error('Erro ao localizar permissões!');
      }
    }
  }

  // function generateRowId(subid) {
  //   const EPOCH = 1300000000000;
  //   let ts = new Date().getTime() - EPOCH; // limit to recent
  //   let randid = Math.floor(Math.random() * 512);
  //   ts = (ts * 64);   // bit-shift << 6
  //   ts = ts + subid;
  //   return (ts * 512) + (randid % 512);
  // }

  async function sha256(message) {
    // console.log("Texto para Codificar: ", message);
    // encode as UTF-8
    const msgBuffer = new TextEncoder().encode(message);

    // hash the message
    const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);
    
    // convert ArrayBuffer to Array
    const hashArray = Array.from(new Uint8Array(hashBuffer));

    // convert bytes to hex string
    const hashHex = hashArray.map(b => ('00' + b.toString(16)).slice(-2)).join('');

    // console.log("Hash final: ", hashHex);
    return hashHex;
  }

  async function Cryptografa(texto) { 
    let strTempChar;
    let textoCodificado = '';

    for (let i=0; i < texto.length; i++) {
      if (texto.charCodeAt(i) < 128) {
        strTempChar = (texto.charCodeAt(i) + 128);
      }

      if (texto.charCodeAt(i) > 128) {
        strTempChar = (texto.charCodeAt(i) - 128);
      }

      textoCodificado += String.fromCharCode(strTempChar);
    }

    return textoCodificado;
  }

  function PasswordChecker(password) {
    // Verifica se a senha atende aos critérios
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    return(regex.test(password));
  };

  return(
    <AuthContext.Provider 
      value={{ 
        signed,
        usuario,
        loading, 
        loadingAuth,
        clientSelected,
        clienteId,
        identificador, 
        clientes,
        perfilUsuario,
        permissoes,
        ligaMenu,
        togleMenu,
        signOut,
        signIn,
        loadClientSelected,
        sha256,
        Cryptografa,
        PasswordChecker,
        processandoImportacao,
        usuarioImportacao,
        togleProcessandoImportacao
      }}
    >
      {children}
    </AuthContext.Provider>
  )
}
